import swal from "sweetalert2";

window.showPopup = function (
    title,
    text,
    confirmText,
    cancelText,
    functionOnConfirm
) {
    return swal
        .fire({
            title: title,
            text: text,
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: cancelText,
            confirmButtonText: confirmText,
        })
        .then((result) => {
            if (result.isConfirmed) {
                functionOnConfirm();
            } else {
                swal.close();
            }
        });
};
